import { SseEventBase } from './sse-event-base.model';
import { SseEventType } from './sse-event-type.model';
import { MessageDesignBUtils } from '../../content/components/message-design-b/message-design-b.utils';
import { runInInjectionContext } from '@angular/core';

export class SseLoginEvent extends SseEventBase {
  type: SseEventType = 'register';
  onMessage = (event: MessageEvent<any>): void => {
    const resp = JSON.parse(event.data);

    runInInjectionContext(this.injector, () => {

      if (resp.server) {
        if (resp.server.started) {
          const client = this.data.getTakeOverOn().getTime();
          const server = new Date(resp.server.started).getTime();
          if (this.data.identityTakeOver() && client < server) {
            this.ngZone.run(() => {
              this.data.identityEnd();
              this.on.takeOver.next(false);
              this.router.navigate([this.router.url]);
              this.messageClientService.messages$.next(MessageDesignBUtils.serverRestartEndsTakeOverIdentity());
            });
          }
        }
      }

      if (resp.deployment) {
        if (resp.deployment.timestamp) {
          this.ngZone.run(() => {
            this.data.setDeploymentTimestamp(resp.deployment.timestamp);
          });
        }

        if (resp.deployment.tag) {
          this.ngZone.run(() => {
            this.data.setDeploymentTag(resp.deployment.tag);
          });
        }

        if (resp.deployment.hash) {
          this.ngZone.run(() => {
            this.data.setDeploymentHash(resp.deployment.hash);
          });
        }
      }
    });
  }



}
